<button class="app-info-trigger" [tippy]="appInfoDropdownTemplate" [tippyOptions]="tippyOptions">
  <i class="material-icons-outlined">info</i>
</button>

<ng-template #appInfoDropdownTemplate>
  <div class="dropdown-content app-info">
    <img alt="Pozi logo" src="assets/img/logo.svg">
    <div class="section">
      <div>Frontend {{ build.version }}</div>
      <div>{{ build.buildDate | formatDate:'dateTime' }}</div>
    </div>
    @if (apiBuild) {
      <div class="section">
        <div>Backend {{ apiBuild.version }}</div>
        <div>{{ apiBuild.buildDate | formatDate:'dateTime' }}</div>
      </div>
    }
  </div>
</ng-template>
